/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_StreetInputs */

const en_orders_street = /** @type {(inputs: Orders_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const es_orders_street = /** @type {(inputs: Orders_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calle`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Orders_StreetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_street = /** @type {((inputs?: Orders_StreetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_StreetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_street(inputs)
	return es_orders_street(inputs)
});